module.exports = __webpack_public_path__ + "static/bisforbabymain-708a4225131201714a50baffc608f407.png";